// extracted by mini-css-extract-plugin
export default {"container":"notfound_container__9toPd","h2":"notfound_h2__0+t5x","h1":"notfound_h1__1Qw+3"};